import { render, staticRenderFns } from "./ResetPasswordCard.vue?vue&type=template&id=53c20e2c&"
import script from "./ResetPasswordCard.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports